<template>
  <div class="wrap">
    <div class="wrapContent">
      <div class="menu">
        <p v-for="(item, i) in menuList" :class=" { act : $route.name == item.href } " @click="$router.push({name: item.href})">
          <i :class="['iconfont', item.icon]"></i>
          {{item.title}}
        </p>
      </div>
      <div class="router-view">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'User',
  components: {

  },
  data() {
    return {

    }
  },
  computed: {
    menuList() {
      return [
        {
          icon: 'icon-jibenxinxi',
          title: this.pc_lang.Basic_Information,
          href: 'UserInfo'
        },
        {
          icon: 'el-icon-location-information',
          title: this.pc_lang['Address_management'],
          href: 'UserAddress'
        },
        {
          icon: 'icon-anquanshezhi',
          title: this.pc_lang.Security_Settings,
          href: 'UserSafety'
        },
        {
          icon: 'icon-zhanghaobangding',
          title: this.pc_lang.Account_binding,
          href: 'UserBind'
        },
        {
          icon: 'icon-xiaoxitixing',
          title: this.pc_lang.message_notification,
          href: 'UserMsg'
        }
      ]
    }
  },
  async mounted() {

  },
  created() {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>

.wrapContent{
  background: #fff;
  margin: 20px auto 40px;
  border: $border;
  display: flex;
  border-radius: 6px;
  .menu{
    width: 180px;
    padding: 20px 25px;
    background: #FAFAFA;
    border-radius: 6px 0 0 6px;
    >p{
      height: 50px;
      display: flex;
      align-items: center;
      border-bottom: $border;
      cursor: pointer;
      font-weight: 600;
      @extend .transition;
      &:hover{
        color: $blue;
        @extend .transition;
      }
      i{
        font-weight: 500;
        font-size: 30px;
        height: 30px;
        margin-right: 8px;
      }
      &.act{
        color: $blue;
      }
    }
  }
  .router-view{
    flex: 1;
    padding: 30px;
    ::v-deep div.item_line{
      padding: 32px 5px;
      border-bottom: $border;
    }
  }
}
</style>